var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolvedIcon,{tag:"component",attrs:{"size":_vm.size,"stroke-width":1.75,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }